function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15mm",
    height: "15mm",
    viewBox: "0 0 15 15",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      strokeWidth: 0.293162
    },
    d: "M 0.7575858,14.725566 C 0.4029504,14.51575 0.2868889,13.721939 0.2295193,11.113821 0.1890776,9.2752671 0.1208915,6.2104762 0.0779948,4.3031735 L -2e-7,0.83535047 0.9238554,0.36971717 c 0.7833401,-0.3948116 1.5668723,-0.4393265 5.1515163,-0.2926732 2.3252123,0.095128 5.2844773,0.2518931 6.5761443,0.3483667 L 15,0.60081727 V 7.6298441 C 15,13.777766 14.93992,14.680451 14.520671,14.831023 13.73533,15.113078 1.2508786,15.017419 0.7575858,14.725566 Z M 14.09091,7.6582441 V 1.4477728 L 10.075758,1.2551141 C 4.7407337,0.99912397 1.2027497,1.1382111 1.2424248,1.6023747 c 0.016667,0.1949851 0.050758,3.0346782 0.075758,6.3104284 l 0.045455,5.9559119 H 7.7272743 14.090911 Z M 6.2121222,10.081519 V 7.3815131 L 5.2272735,7.2926431 C 4.5960763,7.2356831 4.2424248,7.0510047 4.2424248,6.7783483 c 0,-0.2726565 0.3536515,-0.4573357 0.9848487,-0.5142953 0.9677102,-0.087327 0.9848487,-0.1136495 0.9848487,-1.5126124 0,-1.87281 0.7193609,-1.7416824 0.8508278,0.155092 L 7.156201,6.251947 8.4389383,6.178119 C 10.015729,6.0873641 10.639061,6.3703352 10.129126,6.9454019 9.9234008,7.1774031 9.2215848,7.3455741 8.4591167,7.3455741 H 7.1439556 l -0.087124,2.600496 C 6.9976077,11.713578 6.848369,12.584196 6.5909145,12.664045 6.3056197,12.752535 6.2121268,12.115103 6.2121268,10.081519 Z",
    id: "path1993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ce1520dbf5ae15aafb6b02d2716221cf.svg";
export { ForwardRef as ReactComponent };